import axios from "axios";

import { LMS_BASE_URL } from "../../../../utils/http/http-common";

import { LMS_TOKEN } from "../../../../utils/cookiesmanager";
import { getLMSData } from "../../../../utils/getLMSData";

export const getPostModuleFeedbackQuestionsApiCall = async ({
  module,
  languageId = 1,
  courseId,
  moduleId,
}) => {
  const token = localStorage.getItem(LMS_TOKEN);

  console.log(languageId,'languageId')

  try {
    const response = await axios.get(
      `${LMS_BASE_URL}/course/feedback-questions?type=${module}&languageId=${languageId}&courseId=${courseId}&moduleId=${moduleId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response?.data;
  } catch (error) {
    const { response } = error || {};

    if (response?.data?.statusCode === 401) {
      getLMSData();
    }
    throw error?.response?.data || error;
  }
};

export const savePostModuleFeedbackApiCall = async (args) => {
  const token = localStorage.getItem(LMS_TOKEN);

  try {
    const response = await axios.post(
      `${LMS_BASE_URL}/course/module-feedback`,
      args,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
